import endpointsConfig from "endpoints.config";
import axiosInstance from "services/axiosInstance";

const baseURI = endpointsConfig.UserBaseUrl;

type queryKey = {
  userId: string | undefined;
};
export const getGatewayListByUserId = async ({
  userId,
}: queryKey): Promise<any[]> => {
  // const [_key, { userId }] = queryKey

  const url = `${baseURI}api/Gateway/getgatewaylist`;

  try {
    const response = await axiosInstance.get(url);
    return JSON.parse(JSON.stringify(response.data));
  } catch (error) {
    console.error("Error fetching gateway list:", error);
    throw error;
  }
};
